/** @module constants/external-urls */

/**
 * Email address for SpotHero seller support.
 */
export const supportEmail = 'sellersupport@spothero.com';

/**
 * URL to the operator-facing Intercom help center.
 */
export const helpCenterUrl = 'https://operator-help.spothero.com/';

/**
 * URL to the SpotHero seller terms of use.
 */
export const termsOfUseUrl = 'https://spothero.com/legal/seller-terms-of-use';

/**
 * URL to the SpotHero privacy policy.
 */
export const privacyPolicyUrl = 'https://spothero.com/legal/privacy-policy';
